<template>
    <div id="home1">
        <navbar></navbar>

        <hero-section></hero-section>

        <endorse></endorse>

        <demands></demands>

        <protest-info></protest-info>

        <share-section></share-section>

        <endorsements></endorsements>

        <subscribe></subscribe>

        <contact></contact>

        <public-meeting></public-meeting>

        <social></social>

        <footer-section></footer-section>

        <subscription-modals></subscription-modals>
    </div>
    
</template>

<script>
    "use strict";
    import Navbar from './Elements/Navbar.vue'
    import HeroSection from './Sections/HeroSection.vue'
    import Endorsements from './Sections/Endorsements.vue'
    import Contact from './Sections/Contact.vue'
    import Social from './Sections/Social.vue'
    import FooterSection from './Elements/FooterSection.vue'
    import Demands from "./Sections/Demands";
    import ProtestInfo from "./Sections/ProtestInfo";
    import ShareSection from "./Sections/ShareSection";
    import Endorse from "./Sections/Endorse";
    import Subscribe from "./Sections/Subscribe";
    import PublicMeeting from "./Sections/PublicMeeting";
    import SubscriptionModals from "./Elements/SubscriptionModals";

    export default {
        name: 'Home',
        components: {
            SubscriptionModals,
          PublicMeeting,
          Endorse,
          Subscribe,
          ShareSection,
          ProtestInfo,
          Demands,
          Navbar,
          HeroSection,
          Endorsements,
          Contact,
          Social,
          FooterSection
        },
    }

</script>
